<template>
  <div>
    <div ref="loadingLogoContainer" :class="{ 'scale-[0.25] md:scale-[0.11]': !fullScale }"></div>
    <div ref="loadingTextContainer" class="text"></div>
  </div>
</template>

<script setup lang="ts">
import lottie from 'lottie-web';

import loadingLogo from '@/assets/lottie/loadingLogo.json';
import loadingText from '@/assets/lottie/loadingText.json';

interface Props {
  fullScale?: boolean;
}
defineProps<Props>();
const loadingLogoContainer = ref();
const loadingTextContainer = ref();

const init = () => {
  lottie.loadAnimation({
    container: loadingLogoContainer.value as Element,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    animationData: loadingLogo,
  });

  lottie.loadAnimation({
    container: loadingLogoContainer.value as Element,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    animationData: loadingText,
  });
};

onMounted(() => {
  init();
});
</script>
